
import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p374619375104065536',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})

